module.exports = __webpack_public_path__ + "img/inject_before.8730ff67.png";